import IComp from '@/models/Comp';

export default interface IProcessCompRequest {
    comp: IComp;
    onUpdateRunPreferencesWhenHasVisited: boolean;
    deferDataFeeds?: boolean;
}

/**
 * Convenience method for getting a new request.
 * The onUpdateRunPreferencesWhenHasVisited flag defaults to false.
 * @param comp
 * @returns
 */
export function newProcessCompRequest(comp: IComp): IProcessCompRequest {
    const request: IProcessCompRequest = {
        comp: comp,
        onUpdateRunPreferencesWhenHasVisited: false
    };
    return request;
}
